import React, { useState } from "react"
import { Container, Row, Col } from "reactstrap"
import MetaTags from "react-meta-tags"
import { Redirect } from "react-router-dom"
import { isEmpty } from "lodash"

import { retrieveValues } from "../helpers/storagewrapper.js"
// //Import Images
// import error from "../../assets/images/error-img.png"

const Pages404 = () => {
  const [timeout, setTimeOut] = useState(false)
  if (retrieveValues("authUser")) {
    const obj = JSON.parse(retrieveValues("authUser"))
    const controls = obj?.data?.controls || {}
    if (!isEmpty(controls)) {
      let controlAccess = false
      Object.keys(controls).map((type, index) => {
        let findIndex = controls[type].findIndex(
          el => el.key == module && el.selected == true
        )
        if (findIndex > -1) {
          controlAccess = true
        }
      })

      if (!controlAccess) {
        setTimeout(() => {
          localStorage.clear()
          setTimeOut(true)
        }, 1000)
      }
    }
  }
  return timeout ? (
    <Redirect to="/login" />
  ) : (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{process.env.REACT_APP_TITLE}</title>
        </MetaTags>
        <Container fluid>
          <Row>
            <Col lg="12">
              <div className="text-center mb-5">
                <h1 className="display-2 font-weight-medium">
                  4<i className="bx bx-buoy bx-spin text-primary display-3" />3
                </h1>
                <h4 className="text-uppercase">
                  Sorry, You are not authorized to access this page. Please
                  contact to system administrator.
                </h4>
                {/* <div className="mt-5 text-center">
                  <Link className="btn btn-primary " to="/dashboard">
                    Back to Dashboard
                  </Link>
                </div> */}
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Pages404
